<template>
  <div class="user-nav-wrapper">
    <section
      class="user-info-bar"
      v-if="userProfile"
      :class="{ 'user-info-bar--alert': hasOverdueManualInstallments }"
    >
      <div class="info-row">
        <div
          v-if="hasOverdueManualInstallments"
          class="alert-chip"
          role="button"
          tabindex="0"
          @click="openOverdueManualInstallments"
          @keydown.enter.prevent="openOverdueManualInstallments"
        >
          <span class="material-icons" aria-hidden="true">error_outline</span>
          Rate manuali scadute
        </div>
        <div class="info-chip">
          <span class="label">Nome</span>
          <strong>{{ userProfile.name || '—' }}</strong>
        </div>
        <div class="info-chip">
          <span class="label">Cognome</span>
          <strong>{{ userProfile.surname || '—' }}</strong>
        </div>
        <div class="info-chip info-chip--email">
          <span class="label">Email</span>
          <strong>{{ userProfile.email || '—' }}</strong>
        </div>
        <div class="info-chip">
          <span class="label">Telefono</span>
          <strong>{{ userProfile.phone || '—' }}</strong>
        </div>
        <div class="info-chip">
          <span class="label">Studio</span>
          <strong>{{ userProfile.studio || '—' }}</strong>
        </div>
        <button
          :class="['info-action', 'order-badge', orderBadgeClass]"
          type="button"
          @click="openUserLastOrder"
          :disabled="!userProfile.email"
          title="Ultimo ordine"
        >
          <span class="material-icons" aria-hidden="true">receipt_long</span>
        </button>
        <button
          class="info-action credit-button"
          type="button"
          @click="openCreditModal"
          title="Credito utente"
        >
          <span class="material-icons" aria-hidden="true">account_balance_wallet</span>
          <span class="credit-button__text">Credito</span>
          <strong>{{ formattedCreditTotal }}</strong>
        </button>
      </div>
    </section>

    <nav class="user-nav">
      <ul>
      
      <!-- 3° icona: aggiungiamo red-background -->
      <li class="nav-item red-background" @click="goToConversationTecnica" title="Conversazione Tecnica">
        <span class="material-icons">fitness_center</span>
      </li>

      <!-- 4° icona: aggiungiamo red-background -->
      <li class="nav-item red-background" @click="goTo('UsersTicketNutrizionali')" title="Ticket Nutrizionali">
        <span class="material-icons">restaurant</span>
      </li>

      <li class="nav-item" @click="goTo('UserDetails')" title="Dettagli utente">
        <span class="material-icons">person</span>
      </li>

      <li class="nav-item" @click="goTo('UserComunicazioni')" title="Comunicazioni">
        <span class="material-icons">task_alt</span>
      </li>


      <li class="nav-item" @click="goTo('UserCheck')">
        <span class="material-icons">auto_mode</span>
        <span>Check storico</span>
      </li>


      <li class="nav-item" @click="goTo('UserCheckCreate')">
        <span class="material-icons">auto_mode</span>
        <span>Crea Check</span>
      </li>

    
<li class="nav-item" @click="goTo('UserOrdini')">
        <span class="material-icons">shopping_cart</span>
      </li>


      
      <li class="nav-item" @click="goTo('UserProgrammi', userId)">
        <span class="material-icons">assignment</span>
        <span>Percorsi</span>
      </li>


                  <li class="nav-item" @click="goTo('UserSedutePt', userId)" title="SedutePt">
        <span class="material-icons">accessibility</span>
                <span>Sedute Pt</span>

      </li>
      <li class="nav-item" @click="goTo('UserAlimentazione', userId)" title="Programmi">
        <span class="material-icons">content_paste</span>
      </li>

      <li
        class="nav-item allenamenti-nav-item"
        :class="{ 'allenamenti-nav-item--active': $route.name === 'UserAllenamenti' }"
        role="button"
        tabindex="0"
        title="Allenamenti"
        :aria-current="$route.name === 'UserAllenamenti' ? 'page' : undefined"
        @click="goTo('UserAllenamenti', userId)"
        @keydown.enter.prevent="goTo('UserAllenamenti', userId)"
        @keydown.space.prevent="goTo('UserAllenamenti', userId)"
      >
        <span class="material-icons" aria-hidden="true">fitness_center</span>
        <span>Allenamenti</span>
      </li>

      <li class="nav-item" @click="goTo('UserConsulenze', userId)" title="Consulenze">
        <span class="material-icons">video_call</span>
      </li>




      <li class="nav-item" @click="goTo('UserDocumenti')" title="Documenti">
        <span class="material-icons">folder</span>
      </li>
    </ul>
    </nav>
  </div>

  <div class="modal" v-if="showOrderModal">
    <div class="modal-content order-modal">
      <span class="close" @click="closeOrderModal">&times;</span>
      <h2>Ultimo ordine</h2>

      <div v-if="orderLoading" class="order-loader">Caricamento…</div>
      <div v-else-if="orderError" class="order-error">{{ orderError }}</div>
      <div v-else-if="selectedOrder" class="order-card">
        <div class="order-card__body">
          <div class="order-field">
            <span class="order-field__label">Codice</span>
            <span class="order-field__value">{{ orderSummary.code }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Data</span>
            <span class="order-field__value">{{ orderSummary.date }}</span>
          </div>
          <div class="order-field" v-if="orderSummary.status && orderSummary.status !== '—'">
            <span class="order-field__label">Stato</span>
            <span class="order-field__value">{{ orderSummary.status }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Totale</span>
            <span class="order-field__value">{{ orderSummary.total }}</span>
          </div>
          <div class="order-field order-field--products" v-if="orderSummary.products.length">
            <span class="order-field__label">Prodotti</span>
            <ul class="order-products">
              <li
                v-for="(product, index) in orderSummary.products"
                :key="index"
                :class="productHighlightClass(product)"
              >
                {{ product }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="order-empty">Nessun ordine trovato per questo utente.</div>
    </div>
  </div>

  <div
    v-if="showCreditModal"
    class="credit-modal-overlay"
    :class="{ 'credit-modal-overlay--full': isSidebarCollapsed }"
  >
    <div class="modal-content credit-modal">
      <button class="close-button" type="button" @click="closeCreditModal" aria-label="Chiudi">&times;</button>

      <div class="credit-modal__header">
        <div>
          <span class="credit-modal__eyebrow">Credito utente</span>
          <h2>{{ userProfile?.name || 'Utente' }} {{ userProfile?.surname || '' }}</h2>
        </div>
        <div class="credit-total">
          <span>Totale</span>
          <strong>{{ formattedCreditTotal }}</strong>
        </div>
      </div>

      <div v-if="canManageCredit" class="credit-actions" role="tablist" aria-label="Tipo movimento credito">
        <button
          type="button"
          :class="{ active: creditFormVisible && creditForm.type === 'add' }"
          @click="openCreditForm('add')"
        >
          Aggiungi credito
        </button>
        <button
          type="button"
          :class="{ active: creditFormVisible && creditForm.type === 'subtract' }"
          @click="openCreditForm('subtract')"
        >
          Scarica credito
        </button>
      </div>

      <p v-if="!canManageCredit" class="credit-notice">Le modifiche manuali al saldo sono riservate a Valerio.</p>

      <form v-if="canManageCredit && creditFormVisible" class="credit-form" @submit.prevent="saveCreditMovement">
        <label>
          <span>Valore</span>
          <input
            v-model="creditForm.amount"
            type="number"
            min="0.01"
            step="0.01"
            placeholder="0,00"
            required
          />
        </label>

        <label>
          <span>Data</span>
          <input v-model="creditForm.date" type="date" required @change="syncDefaultExpiryDate" />
        </label>

        <label v-if="creditForm.type === 'add'">
          <span>Data scadenza</span>
          <input v-model="creditForm.expiryDate" type="date" />
        </label>

        <label class="credit-form__notes">
          <span>Note</span>
          <textarea
            v-model.trim="creditForm.notes"
            rows="3"
            placeholder="Motivo del credito o dello storno"
          ></textarea>
        </label>
        <div v-if="creditError" class="credit-error">{{ creditError }}</div>

        <button class="credit-save" type="submit" :disabled="creditSaving">
          <span class="material-icons" aria-hidden="true">save</span>
          {{ creditSaving ? 'Salvataggio...' : 'Salva movimento' }}
        </button>
      </form>

      <div
        v-if="creditNotice"
        class="credit-notice"
        :class="`credit-notice--${creditNotice.type}`"
      >
        {{ creditNotice.message }}
      </div>

      <section class="credit-history" aria-label="Storico credito">
        <h3>Storico</h3>
        <div v-if="!creditMovements.length" class="credit-empty">Nessun credito registrato.</div>
        <div v-else class="credit-history__list">
          <article
            v-for="movement in sortedCreditMovements"
            :key="movement.id"
            :class="['credit-entry', `credit-entry--${movement.type}`]"
          >
            <div class="credit-entry__main">
              <span class="credit-entry__type">{{ movement.type === 'add' ? 'Credito' : 'Scaricato' }}</span>
              <strong>{{ movement.type === 'subtract' ? '-' : '+' }}{{ formatCurrency(movement.amount) }}</strong>
            </div>
            <div class="credit-entry__meta">
              <span>Data: {{ formatCreditDate(movement.date) }}</span>
              <span v-if="movement.expiryDate">Scadenza: {{ formatCreditDate(movement.expiryDate) }}</span>
            </div>
            <p v-if="movement.notes">{{ movement.notes }}</p>
          </article>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDoc, collection, query, where, getDocs, runTransaction } from 'firebase/firestore';
import { useOrderBadge } from '@/composables/useOrderBadge';
import { notifyCreditMovement } from '@/lib/creditNotifications';
import { canManuallyManageCredit } from '@/lib/creditPermissions';
import { isManualInstallmentOperationallyExpired } from '@/lib/manualInstallments';

const emptyCredit = () => ({
  totale: 0,
  movimenti: [],
  updatedAt: null,
});

const normalizeAmount = (value) => {
  const numeric = Number(String(value ?? '').replace(',', '.'));
  return Number.isFinite(numeric) ? Math.round(numeric * 100) / 100 : 0;
};

const calculateCreditTotal = (movements) =>
  movements.reduce((sum, movement) => {
    const amount = normalizeAmount(movement.amount ?? movement.valore);
    return movement.type === 'subtract' || movement.tipo === 'subtract' || movement.tipo === 'scala'
      ? sum - amount
      : sum + amount;
  }, 0);

const normalizeCreditMovement = (movement, index) => {
  const type = movement.type || movement.tipo || 'add';
  return {
    id: movement.id || `${movement.createdAt || movement.data || Date.now()}-${index}`,
    type: type === 'subtract' || type === 'scala' ? 'subtract' : 'add',
    amount: normalizeAmount(movement.amount ?? movement.valore),
    date: movement.date || movement.data || '',
    expiryDate: movement.expiryDate || movement.dataScadenza || '',
    notes: movement.notes || movement.note || '',
    createdAt: movement.createdAt || null,
  };
};

const serializeCreditMovement = (movement) => ({
  id: movement.id,
  tipo: movement.type === 'subtract' ? 'subtract' : 'add',
  valore: normalizeAmount(movement.amount),
  data: movement.date || '',
  dataScadenza: movement.expiryDate || '',
  note: movement.notes || '',
  createdAt: movement.createdAt || new Date().toISOString(),
});

const normalizeCredit = (rawCredit) => {
  const base = emptyCredit();
  const source = Array.isArray(rawCredit) ? { movimenti: rawCredit } : rawCredit || {};
  const movementsSource = source.movimenti || source.movements || [];
  const movimenti = Array.isArray(movementsSource)
    ? movementsSource.map(normalizeCreditMovement).filter((movement) => movement.amount > 0)
    : [];
  return {
    ...base,
    ...source,
    movimenti,
    totale: Math.round(calculateCreditTotal(movimenti) * 100) / 100,
  };
};

const toDateInputValue = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const todayInputValue = () => toDateInputValue(new Date());

const addMonthsToDate = (dateValue, months) => {
  const date = dateValue ? new Date(`${dateValue}T00:00:00`) : new Date();
  if (Number.isNaN(date.getTime())) return '';
  date.setMonth(date.getMonth() + months);
  return toDateInputValue(date);
};

const parseCreditDateMs = (value) => {
  if (!value) return 0;
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
};

const parseCreditCreatedMs = (movement) => {
  const fromCreatedAt = movement?.createdAt ? new Date(movement.createdAt).getTime() : 0;
  if (Number.isFinite(fromCreatedAt) && fromCreatedAt > 0) return fromCreatedAt;
  const idMatch = String(movement?.id || '').match(/^credito-(\d+)/);
  return idMatch ? Number(idMatch[1]) : 0;
};

export default {
  props: {
    userId: String,
  },
  setup(props) {
    const router = useRouter();
    const db = getFirestore();
    const auth = getAuth();
    const currentAuthUser = ref(auth.currentUser);
    const canManageCredit = computed(() => canManuallyManageCredit(currentAuthUser.value));
    const userProfile = ref(null);
    const hasOverdueManualInstallments = ref(false);
    const showCreditModal = ref(false);
    const isSidebarCollapsed = ref(false);
    const creditFormVisible = ref(false);
    const creditSaving = ref(false);
    const creditError = ref('');
    const creditNotice = ref(null);
    const creditForm = ref({
      type: 'add',
      amount: '',
      date: todayInputValue(),
      expiryDate: addMonthsToDate(todayInputValue(), 24),
      notes: '',
    });
    const {
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      orderSummary,
      openLastOrder,
      closeOrderModal,
      productHighlightClass,
      orderBadgeStatus,
      prefetchUserHighlights,
    } = useOrderBadge();

    const goTo = (routeName) => {
      router.push({ name: routeName, params: { userId: props.userId } });
    };

    const isInstallmentOverdue = (inst, order = {}) => {
      return isManualInstallmentOperationallyExpired(inst, Date.now(), order);
    };

    const checkManualInstallments = async (email) => {
      hasOverdueManualInstallments.value = false;
      const trimmed = String(email || '').trim();
      if (!trimmed) return;
      try {
        const ordersRef = collection(db, 'orders');
        const snap = await getDocs(
          query(ordersRef, where('userEmail', '==', trimmed), where('paymentMethod', '==', 'rate_manuali')),
        );
        let found = false;
        snap.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const plan = Array.isArray(data.manualInstallments) ? data.manualInstallments : [];
          if (plan.some((inst) => isInstallmentOverdue(inst, data))) {
            found = true;
          }
        });
        hasOverdueManualInstallments.value = found;
      } catch (error) {
        console.error('Errore nel controllo rate manuali:', error);
        hasOverdueManualInstallments.value = false;
      }
    };

    const fetchUserProfile = async (id) => {
      if (!id) {
        userProfile.value = null;
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'users', id));
        if (snap.exists()) {
          const data = snap.data() || {};
          userProfile.value = {
            name: data.name || '',
            surname: data.surname || data.lastName || '',
            email: data.email || data.userEmail || '',
            phone: data.phone || data.telefono || '',
            studio: data.studio || data.studioLabel || '',
            credito: normalizeCredit(data.credito),
          };
          if (userProfile.value.email) {
            prefetchUserHighlights([{ uid: props.userId, email: userProfile.value.email }]);
            checkManualInstallments(userProfile.value.email);
          }
        } else {
          userProfile.value = null;
          hasOverdueManualInstallments.value = false;
        }
      } catch (err) {
        console.warn('Impossibile recuperare il profilo utente:', err);
        userProfile.value = null;
        hasOverdueManualInstallments.value = false;
      }
    };

    const fetchTicketIdForUser = async (userId) => {
      if (!userId) return null;
      try {
        const ticketsRef = collection(db, 'assistenzatecnica');
        const q = query(ticketsRef, where('userId', '==', userId));
        const querySnapshot = await getDocs(q);
        return querySnapshot.empty ? null : querySnapshot.docs[0].id;
      } catch (err) {
        console.error('Nessun ticket tecnico trovato per questo utente', err);
        return null;
      }
    };

    const goToConversationTecnica = async () => {
      const ticketId = await fetchTicketIdForUser(props.userId);
      if (ticketId) {
        router.push({ name: 'UserConversationTecnica', params: { userId: props.userId, ticketId } });
      } else {
        alert('Nessuna conversazione tecnica disponibile per questo utente.');
      }
    };

    const openUserLastOrder = () => {
      if (!userProfile.value?.email) {
        alert('Email non disponibile per questo utente.');
        return;
      }
      openLastOrder({
        uid: props.userId,
        email: userProfile.value.email,
        name: userProfile.value.name,
      });
    };

    const resetCreditForm = (type = 'add') => {
      const today = todayInputValue();
      creditForm.value = {
        type,
        amount: '',
        date: today,
        expiryDate: type === 'add' ? addMonthsToDate(today, 24) : '',
        notes: '',
      };
      creditError.value = '';
      creditNotice.value = null;
    };

    const openCreditModal = () => {
      isSidebarCollapsed.value = document
        .querySelector('.menu-sidebar .sidebar')
        ?.classList.contains('active') === true;
      resetCreditForm('add');
      creditFormVisible.value = false;
      showCreditModal.value = true;
    };

    const closeCreditModal = () => {
      if (creditSaving.value) return;
      showCreditModal.value = false;
      creditError.value = '';
      creditNotice.value = null;
    };

    const openCreditForm = (type) => {
      if (!canManuallyManageCredit(auth.currentUser)) return;
      creditFormVisible.value = true;
      resetCreditForm(type);
    };

    const syncDefaultExpiryDate = () => {
      if (creditForm.value.type !== 'add') return;
      creditForm.value.expiryDate = addMonthsToDate(creditForm.value.date, 24);
    };

    const creditData = computed(() => normalizeCredit(userProfile.value?.credito));
    const creditMovements = computed(() => creditData.value.movimenti);
    const creditTotal = computed(() => creditData.value.totale);

    const sortedCreditMovements = computed(() =>
      creditMovements.value.slice().sort((a, b) => {
        const dateDiff = parseCreditDateMs(b.date) - parseCreditDateMs(a.date);
        if (dateDiff !== 0) return dateDiff;
        return parseCreditCreatedMs(b) - parseCreditCreatedMs(a);
      }),
    );

    const formatCurrency = (value) =>
      new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }).format(normalizeAmount(value));

    const formattedCreditTotal = computed(() => formatCurrency(creditTotal.value));

    const formatCreditDate = (value) => {
      if (!value) return '—';
      const date = new Date(`${value}T00:00:00`);
      if (Number.isNaN(date.getTime())) return value;
      return date.toLocaleDateString('it-IT');
    };

    const saveCreditMovement = async () => {
      if (creditSaving.value) return;
      if (!canManuallyManageCredit(auth.currentUser)) {
        creditError.value = 'Le modifiche manuali al saldo sono riservate a Valerio.';
        return;
      }
      if (!props.userId) {
        creditError.value = 'Utente non disponibile.';
        return;
      }

      const amount = normalizeAmount(creditForm.value.amount);
      if (amount <= 0) {
        creditError.value = 'Inserisci un valore maggiore di zero.';
        return;
      }

      if (creditForm.value.type === 'subtract' && amount > creditTotal.value) {
        creditError.value = 'Non puoi scaricare piu credito del totale disponibile.';
        return;
      }

      if (
        creditForm.value.type === 'add' &&
        creditForm.value.expiryDate &&
        creditForm.value.expiryDate < creditForm.value.date
      ) {
        creditError.value = 'La data di scadenza non puo essere precedente alla data del credito.';
        return;
      }

      creditSaving.value = true;
      creditError.value = '';
      creditNotice.value = null;

      try {
        const userRef = doc(db, 'users', props.userId);
        let savedCredit = null;
        let savedMovement = null;
        await runTransaction(db, async (transaction) => {
          const snap = await transaction.get(userRef);
          if (!snap.exists()) throw new Error('Utente non trovato.');

          const currentCredit = normalizeCredit(snap.data()?.credito);
          const movement = normalizeCreditMovement({
            id: `credito-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
            type: creditForm.value.type,
            amount,
            date: creditForm.value.date,
            expiryDate: creditForm.value.type === 'add' ? creditForm.value.expiryDate || '' : '',
            notes: creditForm.value.notes,
            createdAt: new Date().toISOString(),
          }, currentCredit.movimenti.length);
          savedMovement = movement;
          const movimenti = [...currentCredit.movimenti, movement];
          const totale = Math.round(calculateCreditTotal(movimenti) * 100) / 100;
          if (totale < 0) throw new Error('Credito insufficiente.');

          savedCredit = {
            totale,
            movimenti: movimenti.map(serializeCreditMovement),
            updatedAt: new Date().toISOString(),
          };

          transaction.update(userRef, { credito: savedCredit });
        });

        userProfile.value = {
          ...(userProfile.value || {}),
          credito: normalizeCredit(savedCredit),
        };
        const nextFormType = creditForm.value.type;
        resetCreditForm(nextFormType);
        creditFormVisible.value = false;
        try {
          await notifyCreditMovement({
            db,
            userUid: props.userId,
            movement: savedMovement,
            total: savedCredit?.totale || 0,
            userName: [userProfile.value?.name, userProfile.value?.surname].filter(Boolean).join(' ').trim(),
            notifyUser: true,
            awaitNotification: false,
          });
          creditNotice.value = {
            type: 'success',
            message: 'Credito salvato e notifica inviata all’utente.',
          };
        } catch (notifyError) {
          console.warn('Notifica credito non inviata:', notifyError);
          creditNotice.value = {
            type: 'warning',
            message: 'Credito salvato, ma non è stato possibile inviare la notifica ticket.',
          };
        }
      } catch (error) {
        console.error('Errore nel salvataggio credito:', error);
        creditError.value = error?.message || 'Errore durante il salvataggio del credito.';
      } finally {
        creditSaving.value = false;
      }
    };

    const openOverdueManualInstallments = () => {
      if (!userProfile.value?.email) return;
      router.push({
        path: '/rate-manuali',
        query: { searchEmail: userProfile.value.email, due: 'overdue' },
      });
    };

    const orderBadgeClass = computed(() => {
      if (!userProfile.value?.email) return 'order-badge--neutral';
      const status = orderBadgeStatus({
        uid: props.userId,
        email: userProfile.value.email,
      });
      return `order-badge--${status}`;
    });

    const stopAuth = onAuthStateChanged(auth, (user) => {
      currentAuthUser.value = user;
      if (!canManuallyManageCredit(user)) {
        creditFormVisible.value = false;
        creditError.value = '';
      }
    });
    onUnmounted(stopAuth);
    onMounted(() => fetchUserProfile(props.userId));
    watch(
      () => props.userId,
      (next, prev) => {
        if (next && next !== prev) {
          fetchUserProfile(next);
        } else if (!next) {
          userProfile.value = null;
          hasOverdueManualInstallments.value = false;
        }
      },
    );

    return {
      goTo,
      goToConversationTecnica,
      openUserLastOrder,
      openOverdueManualInstallments,
      userProfile,
      orderBadgeClass,
      hasOverdueManualInstallments,
      showCreditModal,
      isSidebarCollapsed,
      creditFormVisible,
      canManageCredit,
      creditForm,
      creditSaving,
      creditError,
      creditNotice,
      creditMovements,
      sortedCreditMovements,
      formattedCreditTotal,
      openCreditModal,
      closeCreditModal,
      openCreditForm,
      syncDefaultExpiryDate,
      saveCreditMovement,
      formatCurrency,
      formatCreditDate,
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      orderSummary,
      closeOrderModal,
      productHighlightClass,
    };
  },
};
</script>

<style scoped>
.user-nav-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.user-info-bar {
  background: #f6f8fb;
  border: 1px solid #dfe3ec;
  border-radius: 10px;
  padding: 10px 14px;
  margin-top: 34px;
}

.user-info-bar--alert {
  background: linear-gradient(120deg, #fff1f2 0%, #ffe4e6 100%);
  border-color: #fecdd3;
  box-shadow: 0 18px 40px rgba(248, 113, 113, 0.16);
}

.info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.alert-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 12px;
  background: #fee2e2;
  color: #991b1b;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.alert-chip .material-icons {
  font-size: 18px;
}

.info-chip {
  background: #fff;
  padding: 6px 10px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  min-width: 120px;
}

.info-chip .label {
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.info-chip strong {
  font-size: 13px;
  color: #111827;
}

.info-action {
  border: none;
  background: #0ea5e9;
  color: #fff;
  border-radius: 10px;
  padding: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.info-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.order-badge {
  width: 34px;
  height: 34px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f7f9fc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
  padding: 0;
}

.order-badge .material-icons {
  font-size: 20px;
}

.order-badge:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.12);
}

.order-badge--green {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.32);
}

.order-badge--green:hover {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  border: none;
  box-shadow: 0 18px 40px rgba(34, 197, 94, 0.36);
  color: #ffffff;
}

.order-badge--orange {
  border: none;
  background: linear-gradient(120deg, #f97316, #ea580c);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(249, 115, 22, 0.28);
}

.order-badge--orange:hover {
  background: linear-gradient(120deg, #f97316, #ea580c);
  border: none;
  box-shadow: 0 18px 40px rgba(234, 88, 12, 0.32);
  color: #ffffff;
}

.order-badge--neutral {
  background: #f8fafc;
  border-color: rgba(148, 163, 184, 0.45);
}

.info-action .material-icons {
  font-size: 20px;
}

.credit-button {
  min-height: 34px;
  gap: 7px;
  padding: 6px 10px;
  border: 1px solid rgba(14, 165, 233, 0.25);
  background: #e0f2fe;
  color: #075985;
  font-weight: 700;
}

.credit-button:hover {
  transform: translateY(-1px);
  background: #bae6fd;
}

.credit-button .material-icons {
  font-size: 18px;
}

.credit-button__text {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.credit-button strong {
  color: #0f172a;
  font-size: 13px;
}

.user-nav ul {
  list-style-type: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 0px;
}

.nav-item {
  display: flex;
  align-items: center;
  background: linear-gradient(45deg, #dbdbdb 0%, #cbcbcb 100%);
  color: rgb(31, 31, 31);
  border-radius: 13px;
  padding: 7px 10px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 13px;
}

.nav-item:last-child {
  margin-right: 0;
}

.nav-item .material-icons {
  margin-right: 0;
}

.nav-item.red-background {
  background: rgba(0, 106, 148, 0.605);
}

.user-nav:has(.allenamenti-nav-item) ul {
  flex-wrap: wrap;
  row-gap: 8px;
}

.allenamenti-nav-item {
  gap: 5px;
}

.allenamenti-nav-item--active {
  background: #dcefe6;
  color: #166347;
  box-shadow: inset 0 0 0 1px #9dcbb7;
}

.allenamenti-nav-item:focus-visible {
  outline: 2px solid #166347;
  outline-offset: 3px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.modal-content.order-modal {
  width: min(360px, 92vw);
  padding: 26px 30px;
  background: linear-gradient(160deg, #2f3543 0%, #1f262f 100%);
  border-radius: 22px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.45);
  color: #f8fafc;
  position: relative;
}

.order-modal h2 {
  margin: 0 0 16px;
  font-size: 1.3rem;
  text-align: center;
}

.order-card__body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.order-field {
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
}

.order-field__label {
  color: #cbd5f5;
}

.order-field__value {
  font-weight: 600;
}

.order-field--products {
  flex-direction: column;
  align-items: flex-start;
}

.order-products {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.order-products li {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.85rem;
  background: rgba(255, 255, 255, 0.08);
}

.order-product--green {
  background: rgba(34, 197, 94, 0.25);
}

.order-product--orange {
  background: rgba(251, 146, 60, 0.25);
}

.order-loader,
.order-empty,
.order-error {
  text-align: center;
  font-size: 0.95rem;
}

.close {
  position: absolute;
  top: 12px;
  right: 12px;
  cursor: pointer;
  font-size: 1.2rem;
  color: #cbd5f5;
}

.credit-modal-overlay {
  position: fixed;
  top: 0;
  left: 277px;
  width: calc(100vw - 277px);
  height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.credit-modal-overlay--full {
  left: 0;
  width: 100vw;
}

.modal-content.credit-modal {
  width: min(680px, 100%);
  max-height: calc(100vh - 40px);
  overflow: auto;
  padding: 24px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.32);
  color: #0f172a;
  position: relative;
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: #f1f5f9;
  color: #334155;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}

.credit-modal__header {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  align-items: flex-start;
  padding-right: 48px;
  margin-bottom: 18px;
}

.credit-modal__eyebrow {
  display: block;
  margin-bottom: 4px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.credit-modal h2 {
  margin: 0;
  color: #0f172a;
  font-size: 1.35rem;
}

.credit-total {
  min-width: 140px;
  padding: 10px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  text-align: right;
}

.credit-total span {
  display: block;
  margin-bottom: 2px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.credit-total strong {
  font-size: 1.2rem;
  color: #075985;
}

.credit-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 16px;
}

.credit-actions button {
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 9px 12px;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  font-weight: 800;
}

.credit-actions button.active {
  border-color: #0ea5e9;
  background: #e0f2fe;
  color: #075985;
}

.credit-form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
}

.credit-form label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
}

.credit-form input,
.credit-form textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 9px 10px;
  background: #ffffff;
  color: #0f172a;
  font: inherit;
  font-weight: 500;
}

.credit-form textarea {
  resize: vertical;
}

.credit-form__notes,
.credit-error,
.credit-save {
  grid-column: 1 / -1;
}

.credit-error {
  padding: 8px 10px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fef2f2;
  color: #991b1b;
  font-size: 13px;
  font-weight: 700;
}

.credit-notice {
  margin: 12px 0 0;
  padding: 9px 11px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}

.credit-notice--success {
  border: 1px solid #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.credit-notice--warning {
  border: 1px solid #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.credit-save {
  border: 0;
  border-radius: 8px;
  padding: 10px 14px;
  background: #075985;
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-weight: 800;
}

.credit-save:disabled {
  opacity: 0.65;
  cursor: wait;
}

.credit-save .material-icons {
  font-size: 18px;
}

.credit-history {
  margin-top: 18px;
}

.credit-history h3 {
  margin: 0 0 10px;
  color: #0f172a;
  font-size: 1rem;
}

.credit-empty {
  padding: 14px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  color: #64748b;
  text-align: center;
}

.credit-history__list {
  display: grid;
  gap: 10px;
  max-height: 260px;
  overflow: auto;
}

.credit-entry {
  border: 1px solid #e2e8f0;
  border-left-width: 4px;
  border-radius: 8px;
  padding: 11px 12px;
  background: #ffffff;
}

.credit-entry--add {
  border-left-color: #16a34a;
}

.credit-entry--subtract {
  border-left-color: #ea580c;
}

.credit-entry__main {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.credit-entry__main strong {
  white-space: nowrap;
}

.credit-entry__type {
  color: #334155;
  font-weight: 800;
}

.credit-entry__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
}

.credit-entry p {
  margin: 8px 0 0;
  color: #334155;
  font-size: 13px;
  line-height: 1.4;
}

@media (max-width: 720px) {
  .credit-modal-overlay {
    left: 0;
    width: 100vw;
    padding: 12px;
  }

  .credit-modal__header {
    flex-direction: column;
  }

  .credit-total {
    width: 100%;
    box-sizing: border-box;
    text-align: left;
  }

  .credit-form {
    grid-template-columns: 1fr;
  }

  .credit-button {
    width: 100%;
  }
}
</style>
